// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"fff6b275","212":"c878e5e9","325":"1a5ba8b1","407":"efbb94bc","433":"81759362","538":"73024e92","634":"26c68956","722":"78922d25","788":"95b0001f","921":"6dd27c30","977":"f569e22e"}[chunkId] + ".chunk.js";
};